<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<code-example source-code='&lt;div class=&quot;d-of-auto d-p-200 d-ba d-r-both&quot;&gt;.d-r-both&lt;/div&gt;
&lt;div class=&quot;d-of-auto d-p-200 d-ba d-r-inline&quot;&gt;.d-r-inline&lt;/div&gt;
&lt;div class=&quot;d-of-auto d-p-200 d-ba d-r-block&quot;&gt;.d-r-block&lt;/div&gt;
&lt;div class=&quot;d-of-auto d-p-200 d-ba d-r-none&quot;&gt;.d-r-none&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="400" class="d-w50p">
  <div class="d-of-auto d-p-200 d-ba d-r-both">.d-r-both</div>
  <div class="d-of-auto d-p-200 d-ba d-r-inline">.d-r-inline</div>
  <div class="d-of-auto d-p-200 d-ba d-r-block">.d-r-block</div>
  <div class="d-of-auto d-p-200 d-ba d-r-none">.d-r-none</div>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="{ class: className, output, deprecated } in resize">
        <th scope="row" class="d-code--sm d-docsite-code">.{{ className }} <dt-badge v-if="deprecated" type="critical" class="d-ff-sans">Deprecated</dt-badge></th>
        <td class="d-code--sm">{{ output }}</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { resize } from '@data/interactivity.json';
</script>